import { createApp } from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import axiosConfig from './axios';
import store from './store/store';
import App from './App';

// create the app
const app = createApp(App);

axiosConfig(store);

// use axios so we can talk to the API
app.use(VueAxios, axios);
app.use(store);

app.config.devtools = true;

// mount the app
app.mount('#smtp2go-app');
